import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { MentorModel } from 'common/models/page-models/mentor/mentor-data-model';
import { MentorLogsListingModel } from 'common/models/page-models/mentor-mapping/mentor-logs-model';
import { MentorLogDataService } from 'common/services/data-services/admin/mentor/mentor-log-data.service';
import { MentorLogsGridMetaModel } from 'common/models/page-models/mentor-mapping/mentor-logs-grid-meta-model';
import { MentorMappingListDataService } from 'common/services/data-services/custom-service/mentor-list-service';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';


 
@Injectable({
    providedIn: 'root'
})
export class MentorLogsWidgetService extends GridWidgetService<MentorModel, MentorLogsListingModel> {
    constructor(protected override ds: MentorLogDataService, protected systemService: SystemService,protected mentorList: MentorMappingListDataService,
        private batchListService: BatchListDataService) {
        super(ds);
    }

    override prepareMetaModel(
        dataModel: MentorModel,
        metaModel: MentorLogsGridMetaModel,
        routeData: WidgetModel
      ): Promise<MentorLogsGridMetaModel> {
        return new Promise<MentorLogsGridMetaModel>((resolve, reject) => {
            // console.log(routeData)
          this.mentorList.postData({}).then((data) => {
            // console.log(data);
            routeData.transferData.filterMeta.properties.mentorName.options = data.details
          });
          this.batchListService.postData("").then((data) => {
            routeData.transferData.filterMeta.properties.batch_number.options = data.details
          });
          resolve(metaModel);
        });
      }
 
    getMetaModel(): MetaModel {
        const meta = new MentorLogsGridMetaModel().getMetaModel();
        return meta;
    }
}